import { ButtonHTMLAttributes, ReactNode } from 'react'
import styled from 'styled-components'
import { LAYOUT_UNITS } from '@/constants/legacy/constLayout'

interface BottomFixedButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode
  htmlType?: 'submit' | 'button' | 'reset'
  onClick?: () => void
}

export const BottomFixedButton = ({ children, htmlType = 'button', onClick, ...props }: BottomFixedButtonProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <StyledWrapper>
      <div className="button-wrapper">
        {/* eslint-disable-next-line react/button-has-type */}
        <button type={htmlType} className="button-wrapper__button" onClick={handleClick} {...props}>
          {children}
        </button>
      </div>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  padding-bottom: calc(env(safe-area-inset-bottom) + 10rem);
  background-color: ${({ theme }) => theme.color.grayWhite};

  .button-wrapper {
    z-index: 5;
    position: fixed;
    width: 100%;
    max-width: ${LAYOUT_UNITS.BODY_MAX_WIDTH};
    padding: 1.2rem 1.6rem var(--safe-bottom-extra);
    bottom: 0;
    background-color: ${({
      theme: {
        color: { grayWhite },
      },
    }) => grayWhite};
    border-top: 1px solid
      ${({
        theme: {
          color: { gray70 },
        },
      }) => gray70};
    &__button {
      cursor: pointer;
      width: 100%;
      border-radius: 0.8rem;
      background-color: ${({
        theme: {
          color: { blue500 },
        },
      }) => blue500};
      border: none;
      padding: 1.3rem 1.6rem;
      text-align: center;
      z-index: 100;
      &:disabled {
        background-color: ${({ theme }) => theme.color.gray200};
      }
    }
  }
`
